import { call, put, select, takeEvery } from 'redux-saga/effects'
import { startAsyncValidation, stopAsyncValidation } from 'redux-form/immutable'

import api from 'api'
import { locationSelector } from 'utilities/routes'

import { NAME } from './constants'
import actions from './actions'

export function* onSubmit({ payload }) {
  yield put(actions.set({ failed: false }))
  yield put(startAsyncValidation(NAME))

  const { email, userId, token, password } = payload
  let errors = null

  if (email) {
    try {
      yield call([api.user, 'requestPasswordReset'], email)
    } catch (err) {
      errors = { email: 'Den här emailadressen finns inte' }
    }
  } else if (token && password) {
    try {
      yield call([api.user, 'passwordReset'], userId, token, password)
    } catch (err) {
      errors = { password: 'Den här länken har redan använts' }
    }
  }

  yield put(stopAsyncValidation(NAME, errors))
  yield put(actions.set({ failed: errors }))
}

export default function*() {
  yield takeEvery(actions.submit.toString(), onSubmit)

  const request = yield select(locationSelector)
  yield put(actions.set(request.payload))
}



// WEBPACK FOOTER //
// ../source/views/PasswordReset/sagas.js